var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerWorld'),_c('div',{staticClass:"detailBox"},[_c('div',{staticClass:"header-box"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.article.title)+" ")])]),_c('el-divider'),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.article.content)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }